export default __webpack_public_path__ + "static/media/Tunic of the Clay.b8111e6a.jpg";